<template>
    <!-- 兼容 PC 端的设计，PC 端不要使用 mescroll-vue，否则导致 Entity 布局出现问题，popup entity 不再高度居中展示了 -->
    <div v-if="isWebAgent">
        <slot></slot>
    </div>
    <mescroll-vue v-else ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
        <slot></slot>
    </mescroll-vue>
</template>

<script>
    import MescrollVue from 'mescroll.js/mescroll.vue';
    import _ from 'lodash'
    import debounce from 'lodash/debounce';
    import { isWebAgent } from "../../utils";

    export default {
        name: "MescrollWrapper",
        components: {
            MescrollVue
        },
        props: {
            pullDownCallbackHandler: Function,
            preventEleId: String  // the touchmove event of the Element id that should be prevented
        },
        data() {
            return {
                // mscroll -- 超级详细的配置参考 https://www.shuzhiduo.com/A/n2d9aEp4dD/
                mescroll: null, // mescroll实例对象
                mescrollDown: { // 下拉刷新的配置。(如果下拉刷新和上拉加载处理的逻辑是一样的,则 mescrollDown 可不用写了)
                    use: true, // 是否启用下拉刷新，如果配置 false，则不会初始化下拉刷新的布局
                    auto: false, // 是否在初始化完毕之后自动执行一次下拉刷新的回调 callback
                    callback: this.pullDownCallback, // 上拉回调，此处简写; 相当于 callback: function(page, mescroll) { }
                    mustToTop: true,  // 只有在滚动条处于顶部的时候，才能下拉刷新，无效！因为下拉元素不是它控制的。
                    htmlContent: '<p class="downwarp-progress"></p><p class="downwarp-tip">下拉刷新</p>', //布局内容
                    // warpId: 'channel',
                    toTop: { // 回到顶部按钮
                        src: "./static/mescroll/mescroll-totop.png", // 图片路径,默认 null,支持网络图
                        offset: 1000 // 列表滚动 > 100px 才显示回到顶部按钮
                    },
                    // textInOffset: 150,  // 在下拉多少的位置显示提示文本,
                    isBoth: false,
                    hardwareClass: "mescroll-hardware", //硬件加速样式;解决iOS下拉因隐藏进度条而闪屏的问题,参见mescroll.min.css
                },
                // 注意，千万不要配置 mscrollUp 属性，否则 mscroll 会在底部配置没有内容但有高度为 60px 的 div，导致刷新不能触底，UE 体验不好。
                // 但是如果不配置 mescrollUp 属性，mescroll 又会抛出警告，这样，设置为 null 即可。
                mescrollUp: null,
                listening: false // FIX BUG HCF-349：避免 scroll listener 重复的添加（发现手机端 mounted 和 activated 可能同时添加）
            }
        },
        computed: {
            isWebAgent(){
                return isWebAgent();
            }
        },
        // 在使用了 keep-alived 的前提下，
        // mounted 事件是有必要添加的，有种特殊的情况，直接 url 进入某个 entity，然后点击 profile name -> profile，这个时候，activatd
        // 事件是不会被回调的，而只会回调 mounted 方法。应该是第一次初始化的原因，只会调用 mounted 事件。而后 mounted 事件就不会被调用了，
        // 由 activated/deactivated 接管
        created() {
            console.log('mescroll wrapper created');
            this.attachScrollEvent();
        },
        // 无论是第一次初始化还是之后的重新计入，都会回调该方法，
        activated() {
            console.log('mescroll wrapper activated');
            this.attachScrollEvent();
        },
        deactivated() {
            this.detachAllEvents();
        },
        beforeDestroy() {
            this.detachAllEvents();
        },
        // 下面这些方法试过了，注释了对现有的逻辑不会有丝毫的影响。并且因为 mescroll wrapper 是作为子 component 被其他主 component 加载，
        // 下面这些方法本身也对 MescrollWrpper 组件无效。
        // beforeRouteEnter (to, from, next) { // 如果没有配置顶部按钮或isBounce,则beforeRouteEnter不用写
        //     console.log('mescroll wrapper, before route enter');
        //     next(vm => {
        //         // 滚动到原来的列表位置,恢复顶部按钮和isBounce的配置
        //         vm.$refs.mescroll && vm.$refs.mescroll.beforeRouteEnter()
        //     })
        // },
        // beforeRouteLeave (to, from, next) { // 如果没有配置顶部按钮或isBounce,则beforeRouteLeave不用写
        //     console.log('mescroll wrapper, before route leave');
        //     // 记录列表滚动的位置,隐藏顶部按钮和 isBounce 的配置
        //     this.$refs.mescroll && this.$refs.mescroll.beforeRouteLeave()
        //     // 清除 scroll 和 touchmove 事件
        //     window.removeEventListener('scroll', this.handleDebouncedScroll);
        //     // 注意，清除 list 上的 touchmove listener 的时候一定要使用 options=true，这样才能清除所有可能的 list 节点，因为现在开启了
        //     // keep alived，之前的 list 节点其实并不会被清除。使用 options=true 彻底清除。
        //     document.getElementById("list").removeEventListener('touchmove', this.__prevent_scroll_down, true);
        //     console.log('mescroll wrapper, scroll, the scroll and touchmove events get removed');
        //     next()
        // },
        // beforeDestroy() {
        //     // I switched the example from `destroyed` to `beforeDestroy`
        //     // to exercise your mind a bit. This lifecycle method works too.
        //     window.removeEventListener('scroll', this.handleDebouncedScroll);
        //     document.getElementById("list").removeEventListener('touchmove', this.__prevent_scroll_down, false);
        //     console.log('mescroll wrapper, before destroy, the scroll listener get removed');
        // },

        methods: {

            /* =============== Mescroll 方法 - 开始 =============== */

            // mescroll 组件初始化的回调,可获取到 Mescroll 对象
            mescrollInit (mescroll) {
                this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
            },

            attachScrollEvent(){
                // 使用 debounce 监听 scroll 事件，并每隔 300ms 回调一次 handleScroll
                this.p = undefined; // reset it
                this.handleDebouncedScroll = debounce(this.handleScroll, 800);  // 之前设置的 300，android 低端机上抖动特别明显，因此设置为 800，好转很多。
                if ( !this.listening ){
                    window.addEventListener('scroll', this.handleDebouncedScroll);
                    console.log('mescroll wrapper, scroll event listener added');
                    this.listening = true;
                }
            },

            detachAllEvents(){
                if( this.listening ){
                    window.removeEventListener('scroll', this.handleDebouncedScroll);
                    // 有时候，dom 节点被销毁得比 deactivated 事件的回调要快，如果 dom 节点销毁了，也就无需 removeEventListener
                    if(document.getElementById(this.preventEleId))
                        document.getElementById(this.preventEleId).removeEventListener('touchmove', this.__prevent_scroll_down, false);
                    console.log('mescroll wrapper, deactivated, the scroll listener get removed');
                    this.listening = false;
                }
            },

            /**
             * 下拉刷新后的回调方法
             * TODO 实现下拉加载最新更新
             * TODO 实现下拉后的提示信息
             */
            pullDownCallback (){
                (async()=>{
                    try{
                        await this.pullDownCallbackHandler();
                        console.log('mscroll, pull down callback end with success');
                        this.mescroll.endSuccess();
                    } catch (error){
                        console.error('mscroll, pull down callback end with error:', error);
                        this.mescroll.endErr();
                    }
                })();
            },

            /**
             * 解决"在 page num > 1 分页的情况下，下拉动作失效即页面不再向上滚动，且屏幕有明显的抖动的问题"，解决思路如下，
             * 监听 scroll 事件，
             - 当 scroll Y \gt 0 了，表示用户向下拉动屏幕，这个时候禁用 List 元素的下拉刷新事件，
             - 当 scroll Y \le 0 了，表示用户向下拉动屏幕的过程中且滚动条已经到达顶部，这个时候，再次激活 List 元素的下拉刷新事件。
             * 详细分析参考文档《huocool/frontend 组件 scroll - Mescroll.md》
             * ----
             * 天，我发现下面这个方法 js 居然可以并发访问。将 debounce 的间隔设置得长一些，设置为 500ms 就可以最大限度的避免了。不是，后来我发现
             * 是因为我递增的方式写得有问题，使用的是 this.p++，这种写法 this.p 需要在下一次 call 的时候才更新，也就是不会立即更新，导致了
             * 这种并发的假象。
             * TODO 封装成 common method
             */
            handleScroll(event) {
                console.log('mescroll wrapper, handle scroll, this.p:', this.p);
                if(this.p === undefined) this.p = 0; /* add event listener 不允许重复添加，因此写了一个标志位 p 来控制不允许重复添加 */
                console.log('handle scroll, the croll listening, scroll Y:', window.scrollY);
                if(window.scrollY <= 0){
                    // 它的情况和 add event listener 不同，允许重复删除事件
                    if (document.getElementById(this.preventEleId)) { // 避免因为页面刷新没来得及及的问题导致错误
                        document.getElementById(this.preventEleId).removeEventListener('touchmove', this.__prevent_scroll_down, false);
                        this.p = 0; // 重置。
                    }
                    console.log('mescroll wrapper, handle scroll, removed the prevent scroll down event, this.p is reset to', this.p);
                }else{
                    /* add event listener 不允许重复添加，因此写了一个标志位 p 来控制不允许重复添加 */
                    if(this.p === 0){
                        // 注意，千万不能添加 options once=true，否则只会禁止事件执行一次，但是要知道，list page 中中的元素是不断递增的，
                        // 因此，当 list 元素递增的过程中，还得不断的执行禁止事件，将新增的元素也统统禁止。否则问题依旧。
                        if (document.getElementById(this.preventEleId)) { // 避免因为页面刷新没来得及及的问题导致错误
                            this.p += 1;
                            document.getElementById(this.preventEleId).addEventListener('touchmove', this.__prevent_scroll_down);
                            console.log(`mescroll wrapper, handle scroll, p 0 -> ${this.p}, added the prevent scroll down event, `);
                        }
                    }else{
                        console.log(`mescroll wrapper, handle scroll, p=${this.p}, can not duplicate add the prevent scroll down event`);
                    }
                }
            },

            __prevent_scroll_down(e){
                e.stopPropagation()
                console.log('mescroll wrapper, handle scroll, the list scroll down event has been prevented');
            }

            /* =============== Mescroll 方法 - 结束 =============== */
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/MescrollWrapper.vue